import React from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, ScaleIcon, SearchIcon, MessageSquareIcon, CheckCircle2Icon } from 'lucide-react';
const skills = [{
  category: 'Mobile Product Development',
  icon: SmartphoneIcon,
  topBorder: 'border-t-accent',
  iconColor: 'text-accent',
  items: ['iOS & Android Guidelines', 'Cross-platform Strategy', 'App Store Optimization', 'Mobile Analytics (Mixpanel, Amplitude)']
}, {
  category: 'Regulatory & Compliance',
  icon: ScaleIcon,
  topBorder: 'border-t-accent-secondary',
  iconColor: 'text-accent-secondary',
  items: ['HIPAA & GDPR Compliance', 'SOC2 Readiness', 'Accessibility (WCAG 2.1)', 'Audit Trail Design']
}, {
  category: 'Research & Discovery',
  icon: SearchIcon,
  topBorder: 'border-t-accent-secondary',
  iconColor: 'text-accent-secondary',
  items: ['Continuous Discovery Habits', 'Usability Testing', 'Jobs-to-be-Done Framework', 'A/B & Multivariate Testing']
}, {
  category: 'Stakeholder Management',
  icon: MessageSquareIcon,
  topBorder: 'border-t-accent',
  iconColor: 'text-accent',
  items: ['Executive Reporting', 'Cross-functional Alignment', 'Roadmap Prioritization', 'Engineering Collaboration']
}];
export function Expertise() {
  return <section id="expertise" className="py-20 md:py-32 bg-dark text-white" data-id="element-59">
      <div className="max-w-6xl mx-auto px-6" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-62">
            Core Expertise
          </h2>
          <div className="h-1.5 w-20 bg-accent" aria-hidden="true" data-id="element-63" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
          {skills.map((skill, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white/[0.06] p-8 border border-white/10 border-t-4 ${skill.topBorder}`} data-id="element-65">
              <div className="flex items-center space-x-4 mb-6" data-id="element-66">
                <div className={`p-3 bg-white/10 rounded-lg ${skill.iconColor}`} data-id="element-67">
                  <skill.icon className="w-6 h-6" data-id="element-68" />
                </div>
                <h3 className="text-lg font-serif font-bold" data-id="element-69">
                  {skill.category}
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-70">
                {skill.items.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-71">
                    <CheckCircle2Icon className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-72" />
                    <span className="text-gray-300" data-id="element-73">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}